import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ShareGlyph = /*#__PURE__*/createElement("g", {
  id: "share"
}, /*#__PURE__*/createElement("path", {
  d: "M50.6,21.9l-7.2-6.8c0,0,0,0,0,0c-0.1-0.1-0.3-0.2-0.5-0.3c0,0,0,0,0,0c-0.2-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.5,0.1 c0,0,0,0,0,0c-0.2,0.1-0.3,0.2-0.5,0.3c0,0,0,0,0,0l-7.2,6.8c-0.6,0.6-0.6,1.5-0.1,2.1c0.6,0.6,1.5,0.6,2.1,0.1l4.7-4.4v25.6 c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5V19.7l4.7,4.4c0.3,0.3,0.7,0.4,1,0.4c0.4,0,0.8-0.2,1.1-0.5C51.2,23.4,51.2,22.5,50.6,21.9z "
}), /*#__PURE__*/createElement("path", {
  d: "M62.4,68.5H21.6c-2.3,0-4.2-1.8-4.2-4.1V33.6c0-2.2,1.9-4.1,4.2-4.1h10.9c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5H21.6 c-0.7,0-1.2,0.5-1.2,1.1v30.8c0,0.6,0.5,1.1,1.2,1.1h40.7c0.7,0,1.2-0.5,1.2-1.1V33.6c0-0.6-0.5-1.1-1.2-1.1H51.5 c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h10.9c2.3,0,4.2,1.8,4.2,4.1v30.8C66.6,66.7,64.7,68.5,62.4,68.5z"
}));
const Share = createSvg({
  name: 'share',
  path: ShareGlyph
});

export default Share;
export { ShareGlyph };
